export default "__VITE_ASSET__781cb08a__"